import { render, staticRenderFns } from "./ModalFreeProduct.vue?vue&type=template&id=c5e8b51a&scoped=true&"
import script from "./ModalFreeProduct.vue?vue&type=script&lang=js&"
export * from "./ModalFreeProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalFreeProduct.vue?vue&type=style&index=0&id=c5e8b51a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e8b51a",
  null
  
)

export default component.exports